// extracted by mini-css-extract-plugin
module.exports = {"forTitle":"styles_forTitle__1auq2","paginate":"styles_paginate__1IDA8","noData":"styles_noData__1qTtO"};